<template>
  <div class="h-full flex flex-col p-6 max-w-7xl mx-auto">
    <div class="mb-6">
      <h1 class="text-3xl font-extrabold text-gray-900 tracking-tight whitespace-nowrap">
        Time Off Requests
      </h1>
      <p class="text-sm text-slate-500 mt-1">
        Manage pending time off requests, monitor team capacity and view request history.
      </p>
    </div>

    <div class="border-b border-slate-200 mb-6 shrink-0">
      <nav class="-mb-px flex space-x-8" aria-label="Tabs">
        <RouterLink
          :to="{ name: 'AdminTimeOff' }"
          class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors"
          exact-active-class="border-blue-600 text-blue-600"
          inactive-class="border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300"
        >
          Pending Time Off
        </RouterLink>

        <RouterLink
          :to="{ name: 'AdminTimeOffList' }"
          class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors"
          exact-active-class="border-blue-600 text-blue-600"
          inactive-class="border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300"
        >
          All Time Off
        </RouterLink>
      </nav>
    </div>

    <div class="flex-1 min-h-0 flex flex-col">
      <RouterView />
    </div>
  </div>
</template>

<script setup>
import { RouterLink, RouterView } from 'vue-router'
</script>
